export default {
  getUser: '/uauth/auth/get/user'
}